module.exports = __webpack_public_path__ + "img/img-iphonex-mockup.9063c16e.svg";